const PLAN_KEYS = [["pro", "Pro"], ["commercial", "Commercial"], ["custom", "À la carte"]];
const FEAT_KEYS = [["timelines", "Timelines & Calendars"], ["maps", "Maps"], ["relationships", "Relationships"], ["languages", "Languages"], ["commercial", "Commercial license"]];
const NON_PAYING = [["trial", "On trial"], ["referral", "Invite rewards"], ["granted", "Admin grants"], ["event", "Free event"], ["admin", "Admins"], ["billing_paused", "Billing paused"], ["free", "Free plan"]];

const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const money = (n) => (n == null ? "" : Number(n).toFixed(2));
const byKey = (rows, k) => (rows || []).find((r) => r.key === k) || {};

const incomeRows = (records) => {
  const rows = records.map((r) => [r.month, money(r.income?.gross), money(r.income?.refunded), money(r.income?.net), r.income?.payments ?? 0,
    r.paying ?? "", money(r.mrr), r.final ? "Closed" : "In progress"]);
  const sum = (f) => records.reduce((a, r) => a + (r.income?.[f] || 0), 0);
  return [["Month", "Gross", "Refunds", "Net", "Payments", "Paying subscribers", "MRR", "Status"], ...rows,
    ["TOTAL", money(sum("gross")), money(sum("refunded")), money(sum("net")), sum("payments"), "", "", ""]];
};

const planRows = (records) => [
  ["Month", ...PLAN_KEYS.flatMap(([, n]) => [`${n} subscribers`, `${n} monthly`, `${n} yearly`, `${n} MRR`])],
  ...records.map((r) => [r.month, ...PLAN_KEYS.flatMap(([k]) => {
    const p = byKey(r.plans, k);
    return r.plans ? [p.subscribers ?? 0, p.monthly ?? 0, p.yearly ?? 0, money(p.mrr)] : ["", "", "", ""];
  })]),
];

const featureRows = (records) => [
  ["Month", ...FEAT_KEYS.flatMap(([, n]) => [`${n} subscribers with access`, `${n} à la carte MRR`])],
  ...records.map((r) => [r.month, ...FEAT_KEYS.flatMap(([k]) => (r.features ? [byKey(r.features, k).subscribers ?? 0, money(byKey(r.features, k).mrr)] : ["", ""]))]),
];

const nonPayingRows = (records) => [
  ["Month", ...NON_PAYING.map(([, n]) => n)],
  ...records.map((r) => [r.month, ...NON_PAYING.map(([k]) => (r.non_paying ? r.non_paying[k] ?? 0 : ""))]),
];

export const buildRevenueCsv = (title, records) => {
  const sorted = [...records].sort((a, b) => a.month.localeCompare(b.month));
  const lines = [[title], ["Currency: USD. Income = paid Stripe invoices minus refunds. Subscriber figures are the end-of-month snapshot; blank = not recorded."], [],
    ["MONTHLY INCOME"], ...incomeRows(sorted), [], ["SUBSCRIBERS BY PLAN"], ...planRows(sorted), [],
    ["FEATURES"], ...featureRows(sorted), [], ["NON-PAYING ACCOUNTS (excluded from income)"], ...nonPayingRows(sorted)];
  return lines.map((l) => l.map(cell).join(",")).join("\r\n");
};

export const downloadCsv = (filename, csv) => {
  const url = URL.createObjectURL(new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" }));
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
